import { GameLimitsReason } from './notification-center.service';

export enum CustomNotificationChanel {
  UNUSED_BONUSES = 'unused_bonuses',
  INSTALL_APP = 'install_app',
  VIP = 'vip',
  WELCOME_BONUSES = 'welcome_bonuses',
  RELOAD_BONUSES = 'reload_bonuses',
}

export interface IBonusesWS {
  id: number;
  title: string;
  amount_cents: number;
  currency: string;
  stage: string;
  amount_wager_requirement_cents: number;
  amount_wager_cents: number;
  activatable_until: string;
  valid_until: string;
  activatable: boolean;
  cancelable: boolean;
  games: string[];
  games_info: [
    {
      identifier: string;
      title: string;
      frontend_url: string;
    }
  ];
  jackpot: {
    game_identifier: string;
    name: string;
    level_name: string;
    level_index: string;
    win_message: string;
  };
  uid: string;
  notify_channel: string;
}

export interface IFreespinsWS {
  id: number;
  title: string;
  freespins_total: number;
  freespins_performed: number;
  stage: string;
  games: [];
  activation_path: string;
  provider: string;
  activatable_until: string;
  valid_until: string;
  activatable: boolean;
  activation_condition: string;
  cancelable: boolean;
  uid: string;
  notify_channel: string;
}

export interface ILootboxesWS {
  link?: string;
  group_key: string;
  id: number;
  title: string;
  stage: string;
  strategy: string;
  created_at: string;
  valid_until: string;
  uid: string;
  items: [
    {
      weight: number;
      prize: boolean;
      created_at: string;
      bonuses: [
        {
          title: string;
          type: string;
          attributes: [
            {
              field: string;
              value: [
                {
                  currency: string;
                  amount_cents: number;
                }
              ]
            },
            {
              field: string;
              value: number;
            }
          ]
        }
      ]
    },
    {
      weight: number;
      prize: boolean;
      created_at: string;
      bonuses: [
        {
          title: string;
          type: string;
          attributes: [
            {
              field: string;
              value: number;
            }
          ],
          result_bonus: [
            {
              field: string;
              value: number;
            }
          ]
        }
      ]
    },
  ];
  notify_channel: string;
}

export interface IPaymentsWS {
  id: number;
  amount_cents: number;
  currency: string;
  action: string;
  payment_system: string;
  recallable: boolean;
  finished_at: string;
  created_at: string;
  success: boolean;
  notify_channel: string;
  uid: string;
}

export interface IGameLimitWS {
  game: string;
  currency: string;
  amount_cents: number;
  limit_cents: number;
  reason: GameLimitsReason;
  uid: string;
  notify_channel: string;
}

export interface ICompPointsWS {
  chargeable: {
    points: number;
  };
  persistent: {
    points: number;
  };
  uid: string;
  notify_channel: string;
}

export interface ITournamentsStartWS {
  id: number;
  title: string;
  start_at: string;
  end_at: string;
}

export interface ITournamentsStatusItemWS {
  [index: number]: {
    tournament_id: number;
    nickname: string;
    user_confirmed?: any;
    bets: string;
    bet_cents: number;
    wins: string;
    win_cents: number;
    rate: number;
    games_taken: number;
    award_place: number;
    points: number;
    uid: string;
    notify_channel: string;
    link: string;
  };
}

export interface IUserGroupItemWS {
  id: string;
  name: string;
  conditions: any[];
  writable: boolean;
  uid: string;
  notify_channel: string;
}

export type ISockets =
  IBonusesWS
  & ICompPointsWS
  & IFreespinsWS
  & ILootboxesWS
  & IPaymentsWS
  & IGameLimitWS
  & ITournamentsStatusItemWS[]
  & IUserGroupItemWS;
